export default "__VITE_ASSET__C0_G$o4j__"